import { render, staticRenderFns } from "./CreatePurcharseOrders.vue?vue&type=template&id=02b45b43&lang=pug&"
import script from "./CreatePurcharseOrders.vue?vue&type=script&lang=js&"
export * from "./CreatePurcharseOrders.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurcharseOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports